'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var Input = require('./Input.js');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var alloyInput_module = require('./alloy-input.module.scss.js');
var reactI18next = require('react-i18next');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var FilterIcon = require('../alloy-icon/FilterIcon.js');
var CloseIcon = require('../alloy-icon/CloseIcon.js');

var FilterInput = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, setValue = _a.setValue, id = _a.id, label = _a.label, onChange = _a.onChange, error = _a.error, setError = _a.setError, _c = _a.hideLabel, hideLabel = _c === void 0 ? false : _c, placeholder = _a.placeholder, onClear = _a.onClear, validator = _a.validator, onBlur = _a.onBlur, onFocus = _a.onFocus, props = tslib.__rest(_a, ["value", "setValue", "id", "label", "onChange", "error", "setError", "hideLabel", "placeholder", "onClear", "validator", "onBlur", "onFocus"]);
    var t = reactI18next.useTranslation()[0];
    var _d = useDefaultInternalState.default(value, setValue), valueState = _d[0], setValueState = _d[1];
    var _e = useDefaultInternalState.default(error, setError), errorState = _e[0], setErrorState = _e[1];
    var _f = react.useState(true), showFilterIcon = _f[0], setShowFilterIcon = _f[1];
    var clearHandler = function () {
        setValueState('');
        setShowFilterIcon(true);
        if (validator) {
            var result = validator('');
            setErrorState(result);
        }
        else {
            setErrorState();
        }
        onClear && onClear();
    };
    var onInputFocus = function (event) {
        setShowFilterIcon(false);
        onFocus && onFocus(event);
    };
    var onInputBlur = function (event) {
        if (!valueState) {
            setShowFilterIcon(true);
        }
        onBlur && onBlur(event);
    };
    return (jsxRuntime.jsx("div", tslib.__assign({ className: "".concat(alloyInput_module.default['filter-input__search-container']) }, { children: jsxRuntime.jsxs(Input.default, tslib.__assign({ placeholder: placeholder, label: label, hideLabel: hideLabel, id: id, value: valueState, setValue: setValueState, className: "".concat(alloyInput_module.default['filter-input__input'], " ").concat(!showFilterIcon ? 'input-padding' : ''), onChange: onChange, error: errorState, setError: setErrorState, validator: validator, onFocus: onInputFocus, onBlur: onInputBlur }, props, { children: [showFilterIcon ? (jsxRuntime.jsx("span", tslib.__assign({ className: alloyInput_module.default['filter-input__button'] }, { children: jsxRuntime.jsx(FilterIcon.default, {}) }))) : (''), valueState ? (jsxRuntime.jsx(AlloyButton.AlloyButton, tslib.__assign({ alt: t('ORGANIZATIONLIST_CLEARRESULTS'), "aria-label": t('ORGANIZATIONLIST_CLEARRESULTS'), onClick: function () { return clearHandler(); }, addClass: "".concat(alloyInput_module.default['filter-input__clear-button'], " ").concat((!label || hideLabel) && alloyInput_module.default['alloy-top-0']) }, { children: jsxRuntime.jsx(CloseIcon.default, {}) }))) : ('')] })) })));
};
var FilterInput$1 = FilterInput;

exports.default = FilterInput$1;
//# sourceMappingURL=FilterInput.js.map
